function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Google-Logo",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Pfad_3",
  "data-name": "Pfad 3",
  d: "M10.5,12.357V9.625H19.71a9.053,9.053,0,0,1,.136,1.649,9.023,9.023,0,0,1-2.366,6.391,9.144,9.144,0,0,1-6.974,2.8A10.14,10.14,0,0,1,.36,10.47,10.14,10.14,0,0,1,10.505.47a9.529,9.529,0,0,1,6.852,2.756L15.43,5.154A6.965,6.965,0,0,0,10.5,3.2,7.173,7.173,0,0,0,3.33,10.47,7.4,7.4,0,0,0,5.813,16,6.966,6.966,0,0,0,10.5,17.738a6.69,6.69,0,0,0,5.049-2,5.663,5.663,0,0,0,1.481-3.383Z",
  transform: "translate(-0.36 -0.47)",
  fill: "#4285f4"
}));

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.486,
    height: 20,
    viewBox: "0 0 19.486 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.4997c0ab.svg";
export { ForwardRef as ReactComponent };